import React, { Component, Fragment } from 'react'
import { FormInput, FormSubmit } from '@myxplor/forms'
import HeadingRocket from '../heading-rocket'

class ForgotPasswordView extends Component {
  render() {
    const {
      handleChange,
      handleSubmit,
      userType,
      loading,
      prefilledUser,
      errors = {}
    } = this.props

    return (
      <Fragment>
        <HeadingRocket>Password Reset</HeadingRocket>

        <p>Enter the {userType} associated with your account, 
        and we&#39;ll email you a link to get you back on track.</p>

        <form onSubmit={handleSubmit}>
          <fieldset>
            <FormInput
              label={userType}
              name="user"
              required={true}
              onChange={handleChange}
              errors={errors.user}
              loading={prefilledUser || loading}
              value={prefilledUser}
            />
          </fieldset>

          <FormSubmit
            loadingTitle="Requesting reset link"
            errors={errors.submit || errors.summary}
            loading={loading}
          >Request reset link</FormSubmit>
        </form>
      </Fragment>
    )
  }
}

export default ForgotPasswordView


// WEBPACK FOOTER //
// ./src/password-reset/view.jsx